// .popup__wrapper data-component="popup"
// popup__action
// popup popup_hide popup_show
const initPopup = (selectors) => {
    selectors.forEach(selector => {
        popup(selector.wrapper, selector.action, selector.popup);
    });
};
const popup = (wrapperSelector, actionSelector, popupSelector) => {
    const wrappers = document.querySelectorAll(wrapperSelector);
    wrappers.forEach(wrapper => {
        const action = wrapper.querySelector(actionSelector);
        const popup = wrapper.querySelector(popupSelector);
        action && action.addEventListener('click', function (event) {
            const target = event.target;
            if (target.classList.contains('clear-filter'))
                return false;
            // let eventKiller;
            // const docHandler1:(event: MouseEvent) => void = {
            //     closeAllPopup(wrappers, actionSelector, popupSelector);
            //     if(typeof eventKiller === 'function') {
            //         eventKiller();
            //     }
            // }
            // const docHandler: (event: MouseEvent) => void = closeAllPopup(wrappers, actionSelector, popupSelector);
            if (wrapper.dataset.status === 'hide') {
                wrappers.forEach(wrapper => popupHide(wrapper, action, popup));
                popupShow(wrapper, action, popup);
                // document.body.addEventListener('click', docHandler);
                // eventKiller = () => document.body.removeEventListener('click', docHandler);
            }
            else {
                popupHide(wrapper, action, popup);
            }
        });
    });
    const docHandler = closeAllPopup(wrappers, actionSelector, popupSelector);
    document.body.addEventListener('click', docHandler);
};
const closeAllPopup = (wrappers, actionSelector, popupSelector) => {
    return (event) => {
        wrappers.forEach(wrapper => {
            const action = wrapper.querySelector(actionSelector);
            const popup = wrapper.querySelector(popupSelector);
            const elt = event.target;
            if (wrapper.contains(elt) == false) {
                popupHide(wrapper, action, popup);
            }
        });
    };
};
const popupShow = (wrapper, action, popup) => {
    popup.classList.remove('popup_hide');
    popup.classList.add('popup_show');
    action.classList.add('active');
    action.dataset.status = 'show';
    wrapper.dataset.status = 'show';
};
const popupHide = (wrapper, action, popup) => {
    popup.classList.remove('popup_show');
    popup.classList.add('popup_hide');
    action.classList.remove('active');
    wrapper.dataset.status = 'hide';
    action.dataset.status = 'hide';
};
export default initPopup;
